// Generic sort utility: sorts by the given string property
// Constrain: only allow keys whose value is string | null | undefined
export function sortTheList<List>(
  array: List[],
  name: keyof { [Name in keyof List]: List[Name] extends string | null | undefined ? Name : never }
): List[] {
  return [...array].sort((a, b) =>
    ((a[name] as string) ?? "").localeCompare((b[name] as string) ?? "", undefined, { sensitivity: "base" })
  );
}
